import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import {
  CreateTaxDocumentModel,
  CreateTaxDocumentTypeModel,
  DeleteTaxDocumentTypeModel,
  EditTaxDocumentModel,
  SearchTaxDocumentTypeModel,
} from '../../../models/tax-document-type.model'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'

@Injectable({
  providedIn: 'root',
})
export class TaxDocumentTypeService {
  private baseUrl = environment.baseUrl
  private resourceType = 'TipoDocFiscal'
  private resource = 'PessoaDocFiscal'

  constructor(private httpClient: HttpClient) {}

  public createTaxDocumentType(
    model: CreateTaxDocumentTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/create`,
      model,
    )
  }

  public createTaxDocument(
    model: CreateTaxDocumentModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editTaxDocumentType(
    model: any,
    // model: EditTaxDocumentTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/edit`,
      model,
    )
  }

  public editTaxDocument(
    model: EditTaxDocumentModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteTaxDocumentType(
    model: DeleteTaxDocumentTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/delete`,
      model,
    )
  }

  public deleteTaxDocument(
    model: any,
    // model: DeleteContactModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/remove`,
      model,
    )
  }

  public listPagedTaxDocumentType(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedTaxDocumentByPerson(
    idPerson: number,
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/pessoa/${idPerson}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listTaxDocumentType(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/listall`,
    )
  }

  public listTaxDocumentByPerson(
    idPerson: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/list/pessoa/${idPerson}`,
    )
  }

  public getTaxDocumentTypebyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/${id}`,
    )
  }

  public searchPagedTaxDocumentType(
    page: number,
    rows = 15,
    model: SearchTaxDocumentTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
